
const Video = ({videos}) => {

      if(videos.data)return;

      let video_url = videos.data ? 'https://www.youtube.com/embed/' : `https://www.youtube.com/embed/${videos[0].id_video}`;
      
      return(
            <div className="jd_content__col video">
                  <div className="jd_video__wrapper">
                        <div className="jd_corner"></div>
                        <div className="jd_video__box">
                        <iframe width="100%" height="100%" src={video_url} title={videos[0].title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                  </div>
            </div>
      )
}

export default Video;